import { formatCurrency, formatPercent } from '@/lib/display'

const exportFormatters = {
  vmsFeePercent: value => formatPercent(value || 0),
  consultantOverheadPercent: value => formatPercent(value),
  hourlyTotalPayRate: value => formatCurrency(value),
  hourlyNetBillRate: value => formatCurrency(value),
  hourlyExpensesDeduction: value => formatCurrency(value),
  hourlyTotalGrossProfit: value => formatCurrency(value)
}

export const buildNtsExport = ({ items, headers }) => {
  const exportHeaders = headers.filter(header => header.value !== 'actions')
  const keys = exportHeaders.map(header => header.value)
  const data = items.map(item => {
    const row = {}
    keys.forEach(key => {
      const formatter = exportFormatters[key]
      row[key] = formatter ? formatter(item[key]) : item[key]
    })
    return row
  })

  return {
    title: exportHeaders.map(header => header.text),
    key: keys,
    data,
    autoWidthFlag: true,
    filename: 'NTS'
  }
}
